import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query IsAdviceQuestion(
    $partnerId: ID!
    $question: String!
    $languageCode: String!
  ) {
    partner(id: $partnerId) {
      id
      isAdviceQuestion(question: $question, languageCode: $languageCode)
    }
  }
`);
